module.exports = __webpack_public_path__ + "static/img/アセット 8@2x.5bfb191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 8@2x.png
// module id = eFt0
// module chunks = 1